import { useLayoutEffect } from 'react';

import { terminateDataChecksWorker } from 'services/datachecks/datachecks';
import { resetAnnotationAcknowledgments } from 'stores/annotationAcknowledgments/annotationAcknowledgments';
import { resetPackingListStore } from 'stores/packingList/packingList';
import { cleanStore } from 'stores/webedi/webedi';

export const useInitWebEDIStore = () => {
  useLayoutEffect(() => {
    cleanStore();
    resetAnnotationAcknowledgments();
    resetPackingListStore();
    return () => {
      cleanStore();
      resetAnnotationAcknowledgments();
      resetPackingListStore();
      terminateDataChecksWorker();
    };
  }, []);
};

/**
 * Normalizes field paths by converting bracket notation to dot notation.
 * @example
 * normalizePath('modification_groups[0]') // => 'modification_groups.0'
 * normalizePath('items[1].sub[2]') // => 'items.1.sub.2'
 */
export const normalizePath = (path: string): string => {
  return path.replace(/\[(\d+)\]/g, '.$1');
};
